var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value
    ? _c(
        "div",
        {
          staticClass: "activity-popup-overlay",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.closePopup.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "activity-popup-container" }, [
            _c("div", { staticClass: "activity-popup-header" }, [
              _c("img", {
                staticClass: "close-btn",
                attrs: {
                  src: require("../assets/image/close.png"),
                  alt: "Close",
                },
                on: { click: _vm.closePopup },
              }),
            ]),
            _c("div", { staticClass: "activity-popup-body" }, [
              _c("iframe", {
                staticClass: "activity-iframe",
                attrs: {
                  src: _vm.getActivityUrl(),
                  frameborder: "0",
                  allowfullscreen: "",
                  allowTransparency: "true",
                  scrolling: "auto",
                },
                on: { load: _vm.onIframeLoad },
              }),
              _vm.loading
                ? _c("div", { staticClass: "iframe-loading" }, [
                    _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                    _vm._v(" Loading...\n            "),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }